import React, {useEffect} from 'react'
import bridge from '@open-condo/bridge'

export const AppContentWrapper = ({children}) => {
    useEffect(() => {
        if (typeof document !== 'undefined') {
            const observer = new ResizeObserver((entries) => {
                if (entries && entries.length) {
                    bridge.send('CondoWebAppResizeWindow', {
                        height: Math.floor(entries[0].target.getBoundingClientRect().height),
                    })
                }
            })
            observer.observe(document.getElementById('root'))
            return () => observer.unobserve(document.body)
        }
    }, [])

    return <>{children}</>
}
